module.exports = __webpack_public_path__ + "img/beispielrichtig.e59c082e.gif";